import { FileQuestion } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function NotFound() {
	return (
		<div className="min-h-[calc(100vh-3.5rem)] flex items-center justify-center p-6">
			<div className="text-center max-w-sm">
				<div className="rounded-full bg-muted p-4 inline-flex mb-4">
					<FileQuestion className="h-10 w-10 text-muted-foreground" />
				</div>
				<h1 className="text-2xl font-bold tracking-tight mb-2">Page not found</h1>
				<p className="text-muted-foreground mb-6">The page you’re looking for doesn’t exist or was moved.</p>
				<Button asChild>
					<Link to="/" className="focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 rounded-md">Go to dashboard</Link>
				</Button>
			</div>
		</div>
	);
}
